import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../redux/store';
import { ModalProps } from "../../../../components/common/Interfaces/Modals";
import { removeUserGroupUsers } from "../../../../redux/actions/userGroups.actions";
import MultiSelect from "../../../../components/common/UserSelect/MultiSelect";
import ModalShell, { ModalLoading } from "../../../../components/common/Modals/ModalShell";

const RemoveUsersModal: React.FC<ModalProps> = ({open, setOpen}) => {
    const dispatch = useDispatch<AppDispatch>();
    const [selected, setSelected] = useState<any[]>([]);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const {error, data:userGroup, loading} = useSelector((state: RootState) => state.userGroup);

    const handleConfirm = async () => {
        setIsConfirmed(true);
        await dispatch(removeUserGroupUsers({id:userGroup.id!, users: selected}));
    }

    const handleReset = () => {
        setSelected([]);
        setIsConfirmed(false);
    }

    const handleClose = ()=> {
        handleReset();
        setOpen(false);
    }

    const success = !loading && !error && isConfirmed;
    const showForm = !loading && !error && !isConfirmed;

    return (
        <ModalShell
            open={open}
            onClose={handleClose}
            size={showForm ? "md" : "sm"}
            tone={loading ? undefined : error ? "error" : success ? "success" : undefined}
            title={loading ? "Please wait…" : error ? "An error occurred" : success ? "Users removed" : `Remove users from ${userGroup?.name}`}
            subtitle={showForm ? `Remove ${selected.length} ${selected.length===1?`user`:`users`} from ${userGroup?.name}.` : undefined}
            actions={loading ?
                <button className="btn" onClick={handleClose}>Close</button>
                : error ?
                <button className="btn btn-primary" onClick={handleClose}>Close</button>
                : success ?
                <>
                    <button className="btn btn-ghost dlg-actions-start" onClick={handleReset}>Remove more users</button>
                    <button className="btn btn-primary" onClick={handleClose}>Done</button>
                </>
                :
                <>
                    <button className="btn" onClick={handleClose}>Cancel</button>
                    <button className="btn btn-danger" disabled={selected.length===0} onClick={handleConfirm}>Remove</button>
                </>
            }
        >
            {loading ?
                <ModalLoading/>
                : error ?
                <p>{error}</p>
                : success ?
                <p>{`${selected.length} ${selected.length===1 ? `user` : `users`} successfully removed from ${userGroup?.name}.`}</p>
                :
                <div className="dlg-section">
                    <MultiSelect checked={selected} setChecked={setSelected} user_group_id={userGroup?.id}/>
                </div>
            }
        </ModalShell>
    )
};

export default RemoveUsersModal;
